import React from 'react';
import './Message.css';

export enum MessageType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}

interface MessageProps {
  type: MessageType;
  message: string;
  visible: boolean;
  onClose?: () => void;
}

const Message: React.FC<MessageProps> = ({ type, message, visible, onClose }) => {
  if (!visible) return null;

  const getIcon = () => {
    switch (type) {
      case MessageType.SUCCESS:
        return '✅';
      case MessageType.ERROR:
        return '❌';
      case MessageType.WARNING:
        return '⚠️';
      case MessageType.INFO:
        return 'ℹ️';
      default:
        return '';
    }
  };

  return (
    <div className={`message message--${type}`}>
      <div className="message__content">
        <span className="message__icon">{getIcon()}</span>
        <span className="message__text">{message}</span>
        {onClose && (
          <button className="message__close" onClick={onClose} aria-label="关闭">
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default Message; 